// Vendors
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useLayoutContextConsumerHook } from '../contexts/layout.context';
// Event Handlers
import { LayoutHandlers } from '../handlers/layout.handlers';
// Types
import { LayoutBuilderType, LayoutHookType } from 'components/layout/hooks/types/layout.hook.type';
// Utils
import { getTitleValuesFromState } from './utils/layout.hook.utils';

const useLayoutHook = (props: LayoutBuilderType): LayoutHookType => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [maxSteps, setMaxSteps] = useState<number>(0);
  const [renderChildren, setRenderChildren] = useState<boolean>(false);

  const { showBoundary: setError } = useErrorBoundary();

  const { currentState } = useAppContextConsumerHook(),
    { fetching, setFetching } = useFetchErrorContextConsumerHook();

  const { flowApiData: values, setFlowApiData, compactView } = useLayoutContextConsumerHook();

  const { handleFetchFlowInitialDataEvent } = LayoutHandlers({
    ...props,
    currentState,
    setCurrentStep,
    setFetching,
    setFlowApiData,
    setError,
    setMaxSteps,
    setRenderChildren,
  });

  useEffect(() => {
    handleFetchFlowInitialDataEvent();
  }, []);

  return {
    compactView,
    currentStep,
    currentState,
    fetching,
    maxSteps,
    renderChildren,
    values: getTitleValuesFromState({ currentState, values }),
  };
};

export { useLayoutHook };
